import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
// import img1 from "../../images/5510136.jpg";
// import img2 from "../../images/Rent-A-Car-Facebook-Cover-21.jpg";
// import img3 from "../../images/Rent-A-Car-Web-Banner-06.jpg";
import "./slider.css";
import { Fade } from "react-awesome-reveal";
import { useDispatch, useSelector } from "react-redux";
import { GetAllSlideAction } from "../../redux/actions/SlideAction";
import { baseUrlImg } from "../../Api/baseUrl";
function Slider() {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const splitImage=(URL)=>{
    const pathSegments = URL.split('media/');
    const lastSegment = '/media/'+pathSegments[pathSegments.length - 1];
    return lastSegment
  }
  const All = useSelector((state) => state.SlideReduser.GetallSlide);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllSlideAction());
  }, [])
  return (
    <div className="s"id="home">
      <div className="overlay"></div>
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        className="slider"
        interval={2000}
      >
        {All&&All.length>0?All.map((item,idx)=>(
      <Carousel.Item key={idx}>
      <img className="d-block" src={baseUrlImg+splitImage(item.image_url)} alt="First slide" />
      <Carousel.Caption>
        <div className="slider-caption">
        <Fade direction="right"triggerOnce="false">  
            <h3>{item.title}</h3>
          </Fade>
        <Fade direction="right"triggerOnce="false">  
            <p>{item.subtitle}</p>
          </Fade>
        </div>
      </Carousel.Caption>
    </Carousel.Item>
        )):null}
      
      </Carousel>
    </div>
  );
}

export default Slider;
